import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Environment, EnvironmentService } from '@web/service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { cassiopeiaIcons } from '@nestech/utils';

const stripProtocol = /(https?|mailto):\/\/(.*)/;

@Component({
  selector: 'cas-footer-additional-info',
  template: `
    <div class="row d-flex justify-content-between bg-white py-6 px-3">
      @for (info of infos; track info; let isEven = $even; let isOdd = $odd) {
        <div
          class="col-12 col-xxl-auto mt-2 mt-xxl-0"
          [class.col-md-8]="isEven"
          [class.col-md-4]="isOdd">
          @switch (getType(info)) {
            @case ('text') {
              <span>{{ info }}</span>
            }
            @case ('url') {
              <a
                [href]="info"
                class="text-decoration-none text-primary">
                <fa-icon [icon]="icon.globe"></fa-icon>
                <span class="ms-1">{{ stripProtocol(info) }}</span>
              </a>
            }
          }
        </div>
      }
    </div>
  `,
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterAdditionalInfoComponent {
  #environment = inject(EnvironmentService).environment;

  readonly icon = cassiopeiaIcons;
  infos = this.#environment.footerAdditionalInfo;

  getType(info: string): 'text' | 'url' {
    return ['mailto', 'http'].some(type => info.startsWith(type)) ? 'url' : 'text';
  }

  stripProtocol(info: string): string {
    return stripProtocol.exec(info)?.[2] ?? info;
  }
}
